import React from 'react';
import PropTypes from 'prop-types';
import { Router, Route } from 'react-router';

import SafeTradeSellerConversation from './safeTradeSellerConversation.jsx';
import SafeTradeOnboarding from '../onboarding/onboarding.jsx';
import SafeTradeSellerStatus from './safeTradeSellerStatus.jsx';
import {
    hasSeenOnboarding,
    setSeenOnboarding,
} from '../onboarding/onboardingService';

import HandleAgreementSuggestionDetails from './agreement/statusDetails/handleAgreementSuggestionDetails.jsx';
import AgreementRejectedDetails from './agreement/statusDetails/agreementRejectedDetails.jsx';
import AgreementExpiredDetails from './agreement/statusDetails/agreementExpiredDetails.jsx';
import AgreementAcceptedDetails from './agreement/statusDetails/agreementAcceptedDetails.jsx';
import HandleCancelPurchaseDetails from './payment/statusDetails/handleCancelPurchaseDetails.jsx';
import PaymentRevertedDetails from './payment/statusDetails/paymentRevertedDetails.jsx';
import PaymentExpiredDetails from './payment/statusDetails/paymentExpiredDetails.jsx';
import PaidDetails from './payment/statusDetails/paidDetails.jsx';
import ItemApprovedDetails from './payment/statusDetails/itemApprovedDetails.jsx';

import PaymentDelayedDetails from './resolution/statusDetails/paymentDelayedDetails.jsx';
import DiscountSuggestedDetails from './resolution/statusDetails/discountSuggestedDetails.jsx';
import DiscountApprovedDetails from './resolution/statusDetails/discountApprovedDetails.jsx';
import SuggestDiscountPage from './resolution/suggestDiscountPage.jsx';
import SuggestDifferentResolutionPage from './resolution/suggestDifferentResolutionPage.jsx';

import AcceptAgreementError from './agreement/errors/acceptAgreementError.jsx';
import RejectAgreementError from './agreement/errors/rejectAgreementError.jsx';
import ApproveDiscountError from '../resolution/approveDiscountError.jsx';
import SuggestDiscountError from '../resolution/suggestDiscountError.jsx';
import CancelTradeError from './payment/cancelTradeError.jsx';

const App = ({ children }) => <div>{children}</div>;

const SafeTradeAsSeller = ({
    onEnter,
    onOpenFullScreen,
    onCloseFullScreen,
    history,
}) => (
    <Router history={history}>
        <Route path="/" component={App} onEnter={onEnter}>
            <Route
                path="/samtale"
                component={SafeTradeSellerConversation}
                onEnter={onCloseFullScreen}
            />
            {/* TODO: Use `replace` argument to onEnter, this is a hack */}
            <Route
                path="/status"
                component={SafeTradeSellerStatus}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/hva-er-trygg-betaling"
                component={SafeTradeOnboarding}
                onEnter={() => {
                    setSeenOnboarding();
                    onOpenFullScreen();
                }}
            />
            <Route
                path="/behandle-avtaleforslag"
                component={HandleAgreementSuggestionDetails}
                onEnter={(_, replace) => {
                    if (hasSeenOnboarding()) {
                        onOpenFullScreen({ keepHeader: true });
                    } else {
                        replace('/hva-er-trygg-betaling');
                    }
                }}
            />
            <Route
                path="/avslatt-avtale"
                component={AgreementRejectedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/be-om-nytt-avtaleforslag"
                component={AgreementExpiredDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/godkjenn-avtale-feilet"
                component={AcceptAgreementError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/avsla-avtale-feilet"
                component={RejectAgreementError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/avtale-godkjent"
                component={AgreementAcceptedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/avslag-foreslatt"
                component={DiscountSuggestedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/godta-avslag-feilet"
                component={ApproveDiscountError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/enighet-om-avslag"
                component={DiscountApprovedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/foresla-losning"
                component={SuggestDifferentResolutionPage}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/foresla-avslag"
                component={SuggestDiscountPage}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/foresla-avslag-feilet"
                component={SuggestDiscountError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/utsatt-betaling"
                component={PaymentDelayedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/betalingsfrist-har-gatt-ut"
                component={PaymentExpiredDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/hev-avtale"
                component={HandleCancelPurchaseDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/hev-avtale-feilet"
                component={CancelTradeError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/handel-kansellert"
                component={PaymentRevertedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/send-varen"
                component={PaidDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/varen-er-godkjent"
                component={ItemApprovedDetails}
                onEnter={onOpenFullScreen}
            />
        </Route>
    </Router>
);

SafeTradeAsSeller.propTypes = {
    onEnter: PropTypes.func.isRequired,
    onOpenFullScreen: PropTypes.func.isRequired,
    onCloseFullScreen: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

export default SafeTradeAsSeller;



// WEBPACK FOOTER //
// ./safeTrade/seller/safeTradeAsSeller.jsx